import API_ENDPOINTS from "../config/apiEndpoints";
import { requestWithAuth } from "./apiClient";

const normalizePageResponse = (data) => {
  if (Array.isArray(data)) {
    return {
      content: data,
      totalPages: 1,
      number: 0,
      totalElements: data.length,
    };
  }
  return data || { content: [], totalPages: 0, number: 0, totalElements: 0 };
};

export const apiFichajesService = {
  getById: async (id) => {
    const response = await requestWithAuth(API_ENDPOINTS.FICHAJES.ONE, {
      method: "GET",
    });

    return response.json();
  },

  getFichajesEmpleadByEmpleadoIdAndDatePageable: async (
    empresaId,
    empleadoId,
    desde,
    hasta,
    estado = "ACTIVOS",
    page = 0,
    size = 10
  ) => {
    const response = await requestWithAuth(
      API_ENDPOINTS.FICHAJES.ALL_BY_DATES(
        empresaId,
        empleadoId,
        desde,
        hasta,
        estado,
        page,
        size
      ),
      { method: "GET" }
    );

    const data = await response.json();
    return normalizePageResponse(data);
  },

  getFichajesEmpleadByEmpleadoIdAndDate: async (empresaId, empleadoId, desde, hasta, estado = "ACTIVOS") => {
    const pageData = await apiFichajesService.getFichajesEmpleadByEmpleadoIdAndDatePageable(
      empresaId,
      empleadoId,
      desde,
      hasta,
      estado,
      0,
      200
    );
    return pageData.content || [];
  },

  getFichajesEmpleadByEmpleadoIdAndDateRangePageable: async (
    empresaId,
    empleadoId,
    desde,
    hasta,
    estado = "ACTIVOS",
    page = 0,
    size = 10
  ) => {
    // El endpoint /dates fue eliminado; usamos /date?desde=...&hasta=...
    const response = await requestWithAuth(
      API_ENDPOINTS.FICHAJES.ALL_BY_DATES(empresaId, empleadoId, desde, hasta, estado, page, size),
      { method: "GET" }
    );

    const data = await response.json();
    return normalizePageResponse(data);
  },

  getFichajesEmpleadByEmpleadoIdAndDateRange: async (empresaId, empleadoId, desde, hasta, estado = "ACTIVOS") => {
    const pageData = await apiFichajesService.getFichajesEmpleadByEmpleadoIdAndDateRangePageable(
      empresaId,
      empleadoId,
      desde,
      hasta,
      estado,
      0,
      200
    );
    return pageData.content || [];
  },
  getFichajesEmpresaByDatePageable: async (empresaId, desde, hasta, estado = "ACTIVOS", page = 0, size = 10) => {
    const response = await requestWithAuth(
      API_ENDPOINTS.FICHAJES.ALL_BY_EMPRESA_AND_DATES(empresaId, desde, hasta, estado, page, size),
      { method: "GET" }
    );

    const data = await response.json();
    return normalizePageResponse(data);
  },

  getFichajesEmpresaByDate: async (empresaId, desde, hasta, estado = "ACTIVOS") => {
    const pageData = await apiFichajesService.getFichajesEmpresaByDatePageable(
      empresaId,
      desde,
      hasta,
      estado,
      0,
      200
    );
    return pageData.content || [];
  },
  fichar: async (json) => {
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(json),
    };
    const response = await requestWithAuth(
      API_ENDPOINTS.FICHAJES.CREATE,
      options
    );
    let body;
    try {
      body = await response.json();
    } catch (e) {
      body = null;
    }

    if (!response.ok) {
      const error = new Error(body?.error_code || "Error al fichar");
      error.status = response.status;
      error.error_code = body?.error_code;
      error.body = body?.message;
      throw error;
    }

    return body;
  },
  ficharManual: async (json) => {
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(json),
    };
    const response = await requestWithAuth(
      API_ENDPOINTS.FICHAJES.CREATE_MANUAL(),
      options
    );
    return response.json();
  },
  borrarFichaje: async (id, empresaId, motivoEliminacion) => {
    const options = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ empresaId, motivoEliminacion }),
    };
    const response = await requestWithAuth(API_ENDPOINTS.FICHAJES.DELETE(id), options);
    const body = await response.json().catch(() => null);
    if (!response.ok) {
      throw new Error(body?.message || body?.error || "No se pudo eliminar el fichaje.");
    }
    return body;
  },
};
